/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ajax } from 'rxjs/ajax';
import { concat, of, from, defer } from 'rxjs';
import {
    switchMap,
    filter,
    catchError,
    toArray,
    mergeAll,
    map,
    pluck,
} from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { STATUS } from 'sarsaparilla';

import { getTourImagesUrl } from '../api/endpoints';
import { processMediaApiResponse } from '../utils';

import {
    FETCH_TOUR_IMAGES,
    setFetchTourImagesByFacilityStatus,
    fetchTourImagesByFacilitySuccess,
    fetchTourImagesByFacilityError,
} from '../actions/tourImagesActions';

export function fetchTourImagesByFacility(actions$) {
    return actions$.pipe(
        ofType(FETCH_TOUR_IMAGES),
        filter(({ payload }) => !!payload),
        switchMap(({ payload }) => {
            const { facilityId, tourIds } = payload;

            const requests = tourIds.map((id) => {
                return defer(() =>
                    ajax.getJSON(getTourImagesUrl(facilityId, id)).pipe(pluck('result'))
                );
            });

            const ajax$ = from(requests).pipe(mergeAll(5), toArray());

            return concat(
                of(setFetchTourImagesByFacilityStatus(STATUS.PENDING)),
                ajax$.pipe(
                    map((responses) => {
                        const data = {};

                        if (Array.isArray(responses)) {
                            responses.forEach((item) => {
                                const tourId = item?.[0]?.entity_id;

                                if (tourId) {
                                    data[tourId] = processMediaApiResponse(item);
                                }
                            });
                        }
                        return fetchTourImagesByFacilitySuccess(data);
                    }),
                    catchError((error) => of(fetchTourImagesByFacilityError(error)))
                )
            );
        })
    );
}
